



















import { Component, Vue, Prop, Emit } from 'vue-property-decorator'

@Component
export default class SheetList extends Vue {
  private sheet = ''

  @Prop()
  readonly sheetNames!: string[]

  @Emit('getSheetName')
  chooseSheetName (selectedSheetName: string): void {}

  private created (): void {
    this.sheet = this.sheetNames[0]
    this.chooseSheetName(this.sheet)
  }

  public handleChooseSheet (sheetName: string): void {
    this.chooseSheetName(sheetName)
  }
}
